import { render, staticRenderFns } from "./SpiritsFilters.vue?vue&type=template&id=33503f44&scoped=true"
import script from "./SpiritsFilters.vue?vue&type=script&lang=js"
export * from "./SpiritsFilters.vue?vue&type=script&lang=js"
import style0 from "./SpiritsFilters.vue?vue&type=style&index=0&id=33503f44&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33503f44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33503f44')) {
      api.createRecord('33503f44', component.options)
    } else {
      api.reload('33503f44', component.options)
    }
    module.hot.accept("./SpiritsFilters.vue?vue&type=template&id=33503f44&scoped=true", function () {
      api.rerender('33503f44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/SpiritsFilters.vue"
export default component.exports